/* unplugin-vue-components disabled */import { render } from "./scatterChart.vue?vue&type=template&id=4fe0998a"
import script from "./scatterChart.vue?vue&type=script&lang=js"
export * from "./scatterChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__